import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const invoice = {
  merchantOrderList: (params) => {
    const url = api.invoice.merchantOrderList + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  invoiceList: (payloads) => {
    const url = api.invoice.invoiceList
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  orderList: (payloads) => {
    const url = api.invoice.orderList
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  generateInvoice: (payloads) => {
    const url = api.invoice.generateInvoice
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  paid: (payloads) => {
    const url = api.invoice.paid
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  notif: (payloads) => {
    const url = api.invoice.notif
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
}

export default invoice
